export const modifierList = [
  'base',
  'media',
  'CA05C-t',
  'CA05C-d',
  'CA10-d',
  'CA30-m',
  'CA30-t',
  'CA30-d',
  'CA15-m',
  'CA15-t',
  'CA15-d',
  'CA25-m',
];
